import { render, staticRenderFns } from "./CompUspRow.vue?vue&type=template&id=99c9b6c4"
import script from "./CompUspRow.vue?vue&type=script&lang=js"
export * from "./CompUspRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports